export default __webpack_public_path__ + "img/ca3c0acb38593a5d63bcac54565aed2d.svg";